import { monomerSeqToMolfile } from './to-atomic-level-utils';
onmessage = (event) => {
    const { seqList, rolesList, chainStartsList, monomersDict, alphabet, polymerType, start, end } = event.data;
    const resMolList = new Array(end - start);
    const molfileWarningList = new Array(0);
    for (let rowI = start; rowI < end; ++rowI) {
        try {
            const seq = seqList[rowI];
            const roles = rolesList ? rolesList[rowI] : undefined;
            const chainStarts = chainStartsList ? chainStartsList[rowI] : undefined;
            resMolList[rowI - start] = monomerSeqToMolfile(seq, monomersDict, alphabet, polymerType, roles, chainStarts);
        }
        catch (err) {
            const errMsg = err instanceof Error ? err.message : err.toString();
            const msg = `Cannot get molfile of row #${rowI}: ${errMsg}.`;
            molfileWarningList.push(msg);
        }
    }
    postMessage({ molfiles: resMolList, warnings: molfileWarningList });
};
//# sourceMappingURL=seq-to-molfile-worker.js.map